var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlueDropdown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 8,
    viewBox: "0 0 10 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.9 0.489375L9.9 2.78937L5.32 7.62938L0.72 2.78937L0.72 0.489375L5.32 5.32938L9.9 0.489375Z",
    fill: "#0F0E96"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueDropdown);
export default __webpack_public_path__ + "static/media/blue-dropdown.daa2b3ed276140a7303ff2c8bfc7f212.svg";
export { ForwardRef as ReactComponent };